import store from './../game/store/index.js';

const asset = {
	install(Vue, options) {

		Vue.prototype.$asset = {
			isVehicle(asset) {
				return store.state.vehicle_types[asset.type] !== undefined
			},
			workersInVehicle(vehicle) {
				let workers = [];
				vehicle.on_board.forEach((worker_id) => {
					workers.push(store.state.workers[worker_id]);
				});
				return workers;
			},
			queueCleared(vehicle) {
				let queue = [];
				vehicle.queue.forEach((worker_id, index) => {
					let worker = store.state.workers[worker_id];
					if (!worker.clear_queue) queue.push(worker_id);
				})

				return queue.length == 0;
			}
		}
	}
};

export default asset;
